/**
 * Перечисления домена. Значения совпадают с enum'ами Prisma —
 * при изменении правь оба места (schema.prisma и этот файл).
 */
/** Участки производства. */
export const SITE_CODES = ['PRESSING', 'AGGLOMERATION', 'CRUSHING', 'MIXING'];
/**
 * Названия участков.
 *
 * Коды остались прежними, а названия отражают перестроенный техпроцесс:
 * агломерация теперь идёт вместе с капсуляцией, а дробление — вместе
 * с резкой. Менять коды значило бы переносить всю накопленную историю
 * смен и отчётов ради надписи на экране.
 */
export const SITE_NAMES = {
    PRESSING: 'Прессование',
    MIXING: 'Подготовка полимер-песчаной смеси',
    AGGLOMERATION: 'Агломерация и капсуляция',
    CRUSHING: 'Резка и дробление',
};
/** Роль пользователя. Роль строго одна на человека. */
export const ROLES = ['OPERATOR', 'MASTER', 'ADMIN', 'HR', 'MANAGER'];
export const ROLE_NAMES = {
    OPERATOR: 'Оператор',
    MASTER: 'Мастер участка',
    ADMIN: 'Администратор',
    HR: 'HR',
    MANAGER: 'Руководитель',
};
/** Типоразмеры плиты. */
export const PRODUCT_SIZE_CODES = ['SMALL', 'MEDIUM', 'LARGE'];
export const PRODUCT_SIZE_NAMES = {
    SMALL: 'Плита малая',
    MEDIUM: 'Плита средняя',
    LARGE: 'Плита большая',
};
/**
 * Нормативный расход замеса на одну плиту, граммы.
 * Прессовщик расход не вводит — он списывается по норме от выработки.
 */
export const MIX_NORM_PER_PIECE_G = {
    SMALL: 1150,
    MEDIUM: 1800,
    LARGE: 2300,
};
/**
 * Виды сырья и полуфабрикатов. Справочник расширяется администратором.
 *
 * Песок раздвоен намеренно: сушка — такой же передел, как агломерация,
 * и без двух видов сырья потерю влаги некуда записать. В рецептуру замеса
 * идёт только сухой.
 */
export const MATERIAL_CODES = [
    'FILM',
    'CUT_FILM',
    'AGGLOMERATE',
    'CRUSHED',
    'CAPSULATE',
    'COLORANT',
    'SAND_WET',
    'SAND_DRY',
    'MIX',
];
export const MATERIAL_NAMES = {
    FILM: 'Плёнка',
    CUT_FILM: 'Резаная плёнка',
    AGGLOMERATE: 'Агломерат',
    CRUSHED: 'Дроблёнка',
    CAPSULATE: 'Капсулят',
    COLORANT: 'Краситель',
    SAND_WET: 'Песок сырой',
    SAND_DRY: 'Песок сухой',
    MIX: 'Замес',
};
/**
 * Переделы: что во что превращается и с какой нормой выхода.
 *
 * Держим здесь, а не в коде участков, потому что цепочка — это описание
 * производства, а не поведение программы. Нормы правит руководитель,
 * значения ниже — начальные.
 */
export const CONVERSIONS = [
    { machineCode: 'GUILLOTINE', from: 'FILM', to: 'CUT_FILM', yieldBp: 10000 },
    { machineCode: 'AGGLO_1', from: 'CUT_FILM', to: 'AGGLOMERATE', yieldBp: 8500 },
    { machineCode: 'AGGLO_2', from: 'CUT_FILM', to: 'AGGLOMERATE', yieldBp: 8500 },
    { machineCode: 'CRUSHER_1', from: 'CUT_FILM', to: 'CRUSHED', yieldBp: 9000 },
    { machineCode: 'CAPSULATOR', from: 'CRUSHED', to: 'CAPSULATE', yieldBp: 9000 },
    { machineCode: 'SAND_DRYER', from: 'SAND_WET', to: 'SAND_DRY', yieldBp: 8000 },
];
export const SHIFT_STATUSES = [
    'PLANNED',
    'IN_PROGRESS',
    'REPORTED',
    'ACCEPTED',
    'CORRECTED',
];
export const REPORT_STATUSES = ['REPORTED', 'ACCEPTED', 'CORRECTED', 'SUPERSEDED'];
/** Статус фотографий отчёта — виден администратору в списке смен. */
export const PHOTO_STATUSES = ['NONE', 'PENDING', 'UPLOADED'];
/** События внутри смены (крупные кнопки-переключатели в мастере сдачи). */
export const INCIDENT_KINDS = ['STARTUP', 'PURGE', 'REPAIR', 'TRAINING'];
export const INCIDENT_NAMES = {
    STARTUP: 'Запуск',
    PURGE: 'Выгонка',
    REPAIR: 'Ремонт',
    TRAINING: 'Обучение',
};
/** Движение материала внутри отчёта: произведено или израсходовано. */
export const MATERIAL_FLOWS = ['PRODUCED', 'CONSUMED'];
/** Причина движения на складе. */
export const MOVEMENT_KINDS = [
    'OPENING',
    'SUPPLY',
    'PRODUCTION',
    'CONSUMPTION',
    'ADJUSTMENT',
];
export const ASSIGNMENT_STATUSES = [
    'ASSIGNED',
    'ABSENT_PLANNED',
    'ABSENT_UNPLANNED',
    'REPLACED',
];
export const WEEK_PLAN_STATUSES = ['COLLECTING', 'DRAFT', 'PUBLISHED'];
export const ABSENCE_TYPES = ['PLANNED', 'UNPLANNED'];
export const ABSENCE_STATUSES = ['PENDING', 'APPROVED', 'REJECTED'];
/** Этапы воронки найма. */
export const CANDIDATE_STATUSES = [
    'APPLIED',
    'CALL_NO_ANSWER',
    'CALL_DONE',
    'TOUR_SCHEDULED',
    'TOUR_SHOWED',
    'TOUR_NO_SHOW',
    'INTERNSHIP_SCHEDULED',
    'INTERNSHIP_SHOWED',
    'INTERNSHIP_NO_SHOW',
    'INTERNSHIP_PASSED',
    'INTERNSHIP_FAILED',
    'LEFT',
    'HIRED',
    'NOT_SUITABLE',
    'DECLINED',
];
export const APPOINTMENT_KINDS = ['TOUR', 'INTERNSHIP'];
export const ATTENDANCE_STATUSES = ['PENDING', 'SHOWED', 'NO_SHOW'];
export const INTERNSHIP_RESULTS = ['PASSED', 'FAILED', 'LEFT', 'NO_SHOW'];
export const SESSION_KINDS = ['PIN', 'PASSWORD'];
export const NOTIFICATION_CHANNELS = ['TELEGRAM', 'WEBPUSH'];
export const DELIVERY_STATUSES = ['PENDING', 'SENT', 'FAILED'];
/**
 * Назначение фотографии в сменном отчёте.
 *
 * Два снимка отвечают на разные вопросы: что сделали и в каком виде оставили
 * рабочее место. Одним кадром это не показать, поэтому и назначение разное.
 */
export const PHOTO_KINDS = [
    'PRODUCT',
    'WORKPLACE',
    'RECEIPT_CARGO',
    'RECEIPT_WAYBILL',
];
export const PHOTO_KIND_NAMES = {
    PRODUCT: 'Произведённая продукция',
    WORKPLACE: 'Переданное рабочее место',
    RECEIPT_CARGO: 'Привезённое сырьё и машина',
    RECEIPT_WAYBILL: 'Накладная',
};
/**
 * Обязательные снимки сменного отчёта. Список отдельный от общего: приёмка
 * сырья снимает другое, и требовать её кадры от прессовщика нельзя.
 */
export const REPORT_PHOTO_KINDS = ['PRODUCT', 'WORKPLACE'];
/** Снимки приёмки сырья. Именно на них ссылаются, когда спорят о весе. */
export const RECEIPT_PHOTO_KINDS = ['RECEIPT_CARGO', 'RECEIPT_WAYBILL'];
/**
 * Работы бригады, не привязанные к выработке агрегата.
 *
 * Люди с гильотины заняты не только резкой: они палетируют готовую плитку,
 * грузят и разгружают машины, убирают цех. Без этого их смена выглядит
 * простоем, хотя работа сделана.
 */
export const CREW_TASKS = ['LOADING_TRUCK', 'UNLOADING_RAW', 'CLEANING'];
export const CREW_TASK_NAMES = {
    LOADING_TRUCK: 'Погрузка машины',
    UNLOADING_RAW: 'Разгрузка сырья',
    CLEANING: 'Уборка цеха',
};
//# sourceMappingURL=enums.js.map